/**
 * @generated SignedSource<<bce0809a195602c8acddf5b438b0e840>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type IdentityAccountTypes = "CANDIDATE" | "EMPLOYER" | "INTERNAL" | "%future added value";
export type IdentityUserChangePasswordInput = {
  clientMutationId: string;
  identityUserId: string;
  newPassword: string;
  originalPassword: string;
};
export type UseIdentityUserChangePasswordMutation$variables = {
  input: IdentityUserChangePasswordInput;
};
export type UseIdentityUserChangePasswordMutation$data = {
  readonly data: {
    readonly payload: {
      readonly node: {
        readonly __id: string;
        readonly accountTypes: ReadonlyArray<IdentityAccountTypes>;
        readonly code: number;
        readonly createdAt: string;
        readonly email: string;
        readonly firstName: string | null | undefined;
        readonly id: string;
        readonly identityUserId: string;
        readonly lastLoggedIn: string | null | undefined;
        readonly lastName: string | null | undefined;
        readonly updatedAt: string;
      };
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly code?: string;
      readonly message?: string;
    }> | null | undefined;
  };
};
export type UseIdentityUserChangePasswordMutation = {
  response: UseIdentityUserChangePasswordMutation$data;
  variables: UseIdentityUserChangePasswordMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "EdgeOfElevateIdentityUser",
  "kind": "LinkedField",
  "name": "payload",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "IdentityUser",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "identityUserId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastLoggedIn",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accountTypes",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "ElevateUserError",
  "abstractKey": "__isElevateUserError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UseIdentityUserChangePasswordMutation",
    "selections": [
      {
        "alias": "data",
        "args": (v1/*: any*/),
        "concreteType": "IdentityUserChangePasswordPayload",
        "kind": "LinkedField",
        "name": "identityUserChangePassword",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "userErrors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UseIdentityUserChangePasswordMutation",
    "selections": [
      {
        "alias": "data",
        "args": (v1/*: any*/),
        "concreteType": "IdentityUserChangePasswordPayload",
        "kind": "LinkedField",
        "name": "identityUserChangePassword",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "userErrors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "dd3ffccaa5567e57042cd9fada600a43",
    "id": null,
    "metadata": {},
    "name": "UseIdentityUserChangePasswordMutation",
    "operationKind": "mutation",
    "text": "mutation UseIdentityUserChangePasswordMutation(\n  $input: IdentityUserChangePasswordInput!\n) {\n  data: identityUserChangePassword(input: $input) {\n    payload {\n      node {\n        id\n        code\n        identityUserId\n        lastLoggedIn\n        firstName\n        lastName\n        email\n        updatedAt\n        createdAt\n        accountTypes\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "806f1b7cb845dda4475f62e718671a10";

export default node;
